import {
  createRouter,
  createRootRoute,
  createRoute,
  redirect,
  Outlet,
} from '@tanstack/react-router'
import { useAuthStore } from '@/lib/auth/auth-store'
import Layout from '@/components/Layout'
import LoginPage from '@/features/auth/login-page'
import DashboardPage from '@/pages/DashboardPage'
import UsersPage from '@/features/users/users-page'
import RidesPage from '@/pages/RidesPage'
import DriversPage from '@/pages/DriversPage'
import LiveMapPage from '@/pages/LiveMapPage'
import DriverKycList from '@/pages/kyc/DriverKycList'
import DriverKycDetail from '@/pages/kyc/DriverKycDetail'
import RecoveryPage from '@/pages/billing/RecoveryPage'
import SettingsPage from '@/pages/SettingsPage'

const rootRoute = createRootRoute({ component: Outlet })

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  beforeLoad: () => {
    if (useAuthStore.getState().token) throw redirect({ to: '/dashboard' })
  },
  component: LoginPage,
})

const layoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'layout',
  beforeLoad: () => {
    if (!useAuthStore.getState().token) throw redirect({ to: '/login' })
  },
  component: Layout,
})

const indexRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
})

const dashboardRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/dashboard',
  component: DashboardPage,
})

const usersRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/users',
  component: UsersPage,
})

const ridesRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/rides',
  component: RidesPage,
})

const driversRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/drivers',
  component: DriversPage,
})

const liveMapRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/live-map',
  component: LiveMapPage,
})

const kycListRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/kyc',
  component: DriverKycList,
})

const kycDetailRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/kyc/$driverId',
  component: DriverKycDetail,
})

const billingRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/billing',
  component: RecoveryPage,
})

const settingsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/settings',
  component: SettingsPage,
})

const routeTree = rootRoute.addChildren([
  loginRoute,
  layoutRoute.addChildren([
    indexRoute,
    dashboardRoute,
    usersRoute,
    ridesRoute,
    driversRoute,
    liveMapRoute,
    kycListRoute,
    kycDetailRoute,
    billingRoute,
    settingsRoute,
  ]),
])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
